import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f0ad809"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmActionCandidates",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body content mx-0 p-0" }
const _hoisted_8 = { class: "text-center py-4 border-bottom" }
const _hoisted_9 = { class: "px-4" }
const _hoisted_10 = { class: "fw-bold py-4" }
const _hoisted_11 = { class: "bg-light py-3 ps-3 pe-2 mb-4" }
const _hoisted_12 = { class: "list-id" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = { class: "me-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = {
  key: 0,
  class: "error-message fs-7 p-3 mb-4 rounded-1 while-spaces"
}
const _hoisted_17 = {
  key: 1,
  class: "error-message fs-7 p-3 mb-4 rounded-1 while-spaces"
}
const _hoisted_18 = {
  key: 2,
  class: "error-message fs-7 p-3 mb-4 rounded-1 while-spaces"
}
const _hoisted_19 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse mb-4" }
const _hoisted_20 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_21 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { onMounted, PropType, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'
import { numberWithCommas } from '@/constants/common.ts'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import communityAlumnusCandidates from '@/services/community-alumnus-candidates.services'
import { useStore } from 'vuex'
import { CONVERSATIONS_STORE } from '@/store/constants'
import { getMessage } from '@/constants/messageCode.ts'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Array,
  typeModal: Object as PropType<{ type: string; title: string }>,
  reload: Function as PropType<() => void | undefined>,
  getTypeError: Function as PropType<any>,
},
  setup(__props) {

const props = __props

const route = useRoute()
const store = useStore()

const modalSuccess = ref()
const modalConfirm = ref()
const errorMaxUsers = ref(false)
const errorSubmit = ref(false)
const messageCode = ref()


const loadingSubmit = ref<boolean>(false)
const onSubmit = async (): Promise<void> => {
  const { typeModal, data, getTypeError } = props
  loadingSubmit.value = true
  try {
    let response
    if (typeModal?.type === 'approve') {
      response = await communityAlumnusCandidates.postAlumnusCandidatesApi({
        id: route.params?.id,
        payload: { users_management_no: data?.map((item: any) => item.management_no) },
        action: 'permission',
      })
    }

    if (typeModal?.type === 'reject') {
      response = await communityAlumnusCandidates.postAlumnusCandidatesApi({
        id: route.params?.id,
        payload: { users_management_no: data?.map((item: any) => item.management_no) },
        action: 'denial',
      })
    }

    if (typeModal?.type === 'delete') {
      response = await communityAlumnusCandidates.postAlumnusCandidatesApi({
        id: route.params?.id,
        payload: { users_management_no: data?.map((item: any) => item.management_no) },
        action: 'delete',
      })
    }
    //2022/10/14 CW-Phuong Fix for UAT Phase2#4503: modalConfirmApproveAlumni CI10 (Ph2-R20221014)
    getTypeError('')
    if (response.status === 200) {
      //2022/11/15 TienNV Fix for UAT Phase2#4726: CI10 (Ph2-R20221116)
      errorMaxUsers.value = false
      errorSubmit.value = false
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'candidates', type: 'unCheckAll', data: [] })
      modalConfirm.value?.hide()
      modalSuccess.value?.show()
      // reload()
      loadingSubmit.value = false
      return
    } else if (response?.response?.status === 400) {
      // 2022/12/15 PhuongTT Fix for UAT Phase2#5218: CI10 (Ph2-R20221222)
      getTypeError(response?.response?.data?.data[0]?.message_code)
      messageCode.value = response?.response?.data?.data[0]?.message_code
      errorSubmit.value = true
      loadingSubmit.value = false
      return
    }
  } catch (error) {
    loadingSubmit.value = false
    modalConfirm.value?.hide()
    console.log(error)
  }
}

onMounted(() => {
  modalSuccess.value = new Modal(document.getElementById('modalSuccessAction'))
})
onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirmActionCandidates'))
})

const resetData = () => {
  errorSubmit.value = false
  errorMaxUsers.value = false
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.typeModal?.title), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('CI10selectedUser', __props.typeModal?.title)), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(numberWithCommas)(__props.data?.length)) + _toDisplayString(_unref(translate)('selectingUserItems')), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "mb-2 d-flex align-items-center",
                      key: index
                    }, [
                      _createVNode(UserAliasIcon, { userType: 2 }),
                      _hoisted_13,
                      _createElementVNode("span", _hoisted_14, _toDisplayString(item?.management_no), 1),
                      _hoisted_15,
                      _createElementVNode("span", null, _toDisplayString(item.family_name + ' ' + item.given_name), 1)
                    ]))
                  }), 128))
                ])
              ]),
              (errorSubmit.value && __props.typeModal?.type === 'approve')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(getMessage)(messageCode.value)), 1))
                : (errorSubmit.value && __props.typeModal?.type === 'reject')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(getMessage)(messageCode.value)), 1))
                  : (errorSubmit.value && __props.typeModal?.type === 'delete')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(getMessage)(messageCode.value)), 1))
                    : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(Button, {
                    title: _unref(translate)('CI12okButton', __props.typeModal?.title.substring(2)),
                    type: 'secondary',
                    onClick: onSubmit,
                    disabled: loadingSubmit.value
                  }, null, 8, ["title", "disabled"])
                ])
              ])
            ])
          ], 32)
        ])
      ], 512), [
        [_directive_click_outside, resetData]
      ])
    ])
  ]))
}
}

})